/**
 * this should provide an v-model with format YYYY-MM-DD
 *
 */
<template>
  <q-input v-model="rawInput"
    hint="Z.B. 01.01.2021 (im Format TT.MM.JJJJ)"
    v-bind="$attrs"
    @blur="doFixDateInput">
    <template v-slot:append v-if="!noPopup">
      <q-icon name="event" class="cursor-pointer">
        <q-popup-proxy ref="qDateProxy" cover transition-show="scale" transition-hide="scale">
          <q-date v-model="rawInput" mask="DD.MM.YYYY" @update:modelValue="applyPopupValue"></q-date>
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>

<script>

import { doParseAndFormat, fixDateInput } from './date';
export default {
  props: {
    modelValue: { required: true, type: String, },
    noPopup: { required: false, type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  mounted() { this.applyNewModelValue(this.modelValue); },
  data: () => ({
    rawInput: ''
  }),
  watch: {
    modelValue(newValue) {
      this.applyNewModelValue(newValue);
    }
  },
  methods: {
    doFixDateInput(event) {
      let newValue = fixDateInput(event);
      this.updateModelValue(newValue);
    },
    applyPopupValue(newValue) {
      this.$refs.qDateProxy.hide()
      if(typeof newValue !== 'string') return;
      this.updateModelValue(newValue);
    },
    updateModelValue(newValue) {
      //console.log('updateModelValue', newValue);
      let result = '';
      try {
        result = doParseAndFormat(newValue, 'dd.MM.yyyy', 'yyyy-MM-dd');
      } catch (e) {
        return;
      }
      if(result === this.modelValue) return;
      this.$emit('update:modelValue', result);
    },
    applyNewModelValue(newValue) {//format is YYYY-MM-DD
      //console.log('applyNewModelValue', newValue);
      try {
        if(typeof newValue !== 'string') throw new Error('not a string');
        if(newValue.length !== 10) throw new Error('not a date');

        let result = doParseAndFormat(newValue, 'yyyy-MM-dd', 'dd.MM.yyyy');

        this.rawInput = result;
      } catch (e) {
        //console.error('error', e);
        this.rawInput = ''
      }
    }
  }
}
</script>
